import { supabase } from './supabase';

export interface StockCategory {
  id: string;
  business_id: string;
  name: string;
  description: string | null;
  order_index: number;
  created_at: string;
  updated_at: string;
}

export async function getStockCategories(businessId: string) {
  const { data, error } = await supabase
    .from('stock_categories')
    .select('*')
    .eq('business_id', businessId)
    .order('order_index');

  if (error) throw error;
  return data as StockCategory[];
}

export async function createStockCategory(category: Omit<StockCategory, 'id' | 'created_at' | 'updated_at'>) {
  const { data, error } = await supabase
    .from('stock_categories')
    .insert([category])
    .select()
    .single();

  if (error) throw error;
  return data as StockCategory;
}

async function updateStockCategory(id: string, updates: Partial<StockCategory>) {
  const { data, error } = await supabase
    .from('stock_categories')
    .update(updates)
    .eq('id', id)
    .select()
    .single();

  if (error) throw error;
  return data as StockCategory;
}

async function deleteStockCategory(id: string) {
  const { error } = await supabase
    .from('stock_categories')
    .delete()
    .eq('id', id);

  if (error) throw error;
}